import Swiper from 'swiper/bundle';

export default function initializeHomeSlider() {
  document.querySelectorAll('.block-home-slider__swiper:not(.block-home-slider__swiper--disabled)').forEach(function (slider) {
    const progress = slider.querySelector('.block-home-slider__progress')
    const slidesCount = slider.querySelectorAll('.swiper-slide').length;
    const widthParts = 100 / slidesCount;

    const swiper = new Swiper(slider, {
      effect: 'creative',
      creativeEffect: {
        prev: {
          scale: 1,
        },
        next: {
          scale: 1,
        },
      },
      speed: 0,
      loop: false,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      on: {
        init: (e) => {
          progress.querySelector('.block-home-slider__progress__item').classList.add('block-home-slider__progress__item--active');
          const activeSlide = e.slides[e.activeIndex];
          activeSlide.querySelector('.block-home-slider__item__background').classList.add('block-home-slider__item__background--active');
          activeSlide.querySelectorAll('.block-home-slider__title__item').forEach((el) => {
            el.classList.add('block-home-slider__title__item--animate');
          });
        },
        slideChange: (e) => {
          const progressSections = progress.querySelectorAll('.block-home-slider__progress__item');
          const activeIndex = e.activeIndex;

          e.slides.forEach((slide, index) => {
            const item = slide.querySelector('.block-home-slider__item__background');
            const titleItems = slide.querySelectorAll('.block-home-slider__title__item');

            if (slide === e.slides[activeIndex]) {
              item.classList.add('block-home-slider__item__background--active');
              titleItems.forEach((el) => {
                el.classList.add('block-home-slider__title__item--animate');
              });
            } else {
              item.classList.remove('block-home-slider__item__background--active');
              titleItems.forEach((el) => {
                el.classList.remove('block-home-slider__title__item--animate');
              });
            }
          });
;
          for (let i = 0; i < progressSections.length; i++) {
            progressSections[i].classList.remove('block-home-slider__progress__item--before');
            progressSections[i].classList.remove('block-home-slider__progress__item--active');
            if (i < activeIndex) {
              progressSections[i].classList.add('block-home-slider__progress__item--before');
            }
            if (i === activeIndex) {
              progressSections[i].classList.add('block-home-slider__progress__item--active');
            }
          }
        },
      },
    });

    progress.querySelectorAll('.block-home-slider__progress__item').forEach((section, index) => {
      section.addEventListener('click', () => {
        swiper.slideTo(index, 5000, true);
      });
    });
  });
}